import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router';
import axios from 'axios';
import Filter from '../components/Filter';
export default function Users() {
    async function getUsers() {
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'PROJECT MANAGER' ? 'project/user_module/' : 'hr/user_module/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                // let dat=[...response.data,...response.data,...response.data,...response.data,...response.data,...response.data,...response.data,...response.data,...response.data,...response.data,...response.data,...response.data]

                // console.log(dat)
                setData(response.data)
            }).catch(err => {
                console.log(err)
            })
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'ACCOUNTANT' ? 'account/projects/' : type == 'CONSULTANT' ? 'consultant/projects/' : type == 'HR' ? 'hr/projects/' : 'project/projects/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                let divs = document.getElementById('selPU');
                for (let i of response.data) {
                    divs.innerHTML += `
                        <option value=${i.slug}>${i.project_name + '&emsp;&emsp;&emsp;&emsp; id : &emsp;' + i.slug}</option>
                        `
                }
                // await response.data.map(pro=>{

                // })
                setLoad(false)
            }).catch(err => {
                setLoad(false)
                console.log(err)
            })
    }
    useEffect(async () => {
        await getUsers()
    }, [])
    const [data, setData] = useState([])
    let navigate = useNavigate();
    let bol = [false, false, false, false, false]
    // const check = async () => {
    //     let div1 = document.getElementById('Fname').value;
    //     let div2 = document.getElementById('Lname').value;
    //     let div3 = document.getElementById('Iemail').value;
    //     let query = {}
    //     query.first_name = div1.length == 0 ? 'none' : div1;
    //     query.last_name = div2.length == 0 ? 'none' : div2;
    //     query.email = div3.length == 0 ? 'none' : div3;
    //     var form_data = new FormData();
    //     for (var key in query) {
    //         form_data.append(key, query[key]);
    //     }
    //     if (div1 != '' || div2 != '' || div3 != '')
    //         await axios({
    //             method: "post",
    //             url: `${process.env.REACT_APP_API_URL1}/hr/user_module/`,
    //             data: form_data,
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //                 'Authorization': `JWT ${localStorage.getItem('access')}`,
    //                 'Accept': 'application/json'
    //             },
    //         }).then(response => {
    //             console.log(div3.id)
    //             setData(response.data)
    //         }).catch(err => {
    //             console.log(err)
    //         })
    //     else getUsers()
    //     setFil({
    //         first_name: div1.length == 0 ? null : 'first name : ' + div1,
    //         last_name: div2.length == 0 ? null : 'last name : ' + div2,
    //         email: div3.length != 0 ? 'email : ' + div3 : null,
    //     })
    // }
    // function clear(id) {
    //     document.getElementById(id).value = '';
    //     check();
    //     return;
    // }
    const Sorter = (i) => {
        return <>
            {/* <i style={{transition:'all 1s',cursor:'pointer'}} onClick={async(e)=>{
                            e.target.style.transform=bol[i]?'rotate(0deg)':'rotate(180deg)';
                            bol[i]=!bol[i]
                            async function sort(){
                                let datae=await data.sort((a,b) => (a.first_name.toLowerCase() > b.first_name.toLowerCase()) ? 1 : ((b.first_name.toLowerCase() > a.first_name.toLowerCase()) ? -1 : 0))
                                return datae
                            }
                            // setData(sort())
                            await sort().then(async e=>await setData(e))
                            console.log(data)
                  }} class="fas fa-sort-down"></i>&emsp; */}
        </>
    }
    const Filtertag = (e) => {
        return <div className='filterBox'>
            {e.name}
            <i style={{ cursor: 'pointer' }} onClick={() => { childFunc.clear(e.id) }} class="fas fa-times"></i>
        </div>
    }
    const [filters, setFil] = useState({})
    const childFunc = () => { }
    let type = localStorage.getItem('type')
    var changes = []
    const [hover, setHov] = useState(false)
    async function changeInv() {
        let notify = document.getElementsByClassName('noti')[0];
        console.log(changes)
        let boler = false;
        for await (let i of changes) {
            let formData = new FormData();
            formData.append('type', i.type_of_account)
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/hr/user_module/${i.id}/`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(async response => {
                console.log(response)
            }).catch(err => {
                if (!boler) {
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        ${err.response.data.message}
                    </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
            })
        }
        await axios.get(`${process.env.REACT_APP_API_URL1}/hr/user_module/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                setData(response.data)
                setHov(false)
                notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                    Users Updated
                </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                changes = []
                console.log(response.data)
            }).catch(err => {
                changes = []
                setHov(false)
                console.log(err)
            })
    }
    const [jhov, setJhov] = useState(false)
    const [sel, setSel] = useState(false)
    const [showP, setShowP] = useState(false)
    const addP = async () => {
        let divs = document.getElementsByClassName('SuserCheck');
        let mems = []
        for (let i = 0; i < divs.length; i++) {
            divs[i].checked ? mems.push(divs[i].id) : console.log('');
        }
        var bodyFormData = new FormData();
        bodyFormData.append('slug', document.getElementById('selPU').value)
        bodyFormData.append('project_members', mems.join(','))
        let notify = document.getElementsByClassName('noti')[0];
        await axios({
            method: "put",
            url: `${process.env.REACT_APP_API_URL1}/hr/user_module/`,
            data: bodyFormData,
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            },
        }).then(async response => {
            setShowP(false)
            setSel(false)
            notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
            ${response.data.message}
        </div>`;
            setTimeout(() => {
                notify.removeChild(notify.lastChild)
            }, 3000);
        }).catch(err => {
            if(err.response.status==500){
                try {
                    notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                    Server busy, Please try after some time
                    </div>`;
                    setTimeout(() => {
                        notify.removeChild(notify.lastChild)
                    }, 3000);
                } catch (e) { console.log(e) }
            }
            try {
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                    ${err.response.data.message}
                </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
            } catch (e) { console.log(e) }
        })
    }
    const ShowSProject = (dat) => {
        if (dat.data && dat.data.length <= 0)
            return <>-</>
        let divs = []
        for (let i of dat.data) {
            divs.push(i.project_name)
        }
        return <>{divs.join(', ')}</>
    }
    function TabRen() {
        const list=[]
        for (let i = 0; i < 20; i++) {
            list.push(
                <tr>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                </tr>
            )
        }
        return (
            <>
                {list}
            </>
        )
    }
    const [load,setLoad]=useState(true)
    return (
        type == 'HR' || type == 'PROJECT MANAGER' ? <div className='Projects Invoices'>
            <div className='ProjectsTop row'>
                <div className="projleft">Users</div>
                <div className="projright row">
                </div>
            </div>
            {/* {showP? */}
            {type == 'HR' ? <div style={{ display: showP ? 'flex' : 'none' }} className='filter  currency'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    <div className='projDetI inputfix Projects'>
                        <i onClick={() => {
                            setShowP(false)
                        }}
                            style={{ color: 'white', marginBottom: '30px' }} class="fas fa-times"></i>
                        <table className='currSelTab'>
                            <select id='selPU'>
                            </select>
                        </table>
                        <button className='currShowButt' onClick={() => { addP() }}> Add </button>
                    </div>
                </div>
            </div>
                : <></>}
            <div className="projright row">
                {hover ? <>
                    <button onClick={() => { setHov(false); changes = [] }}>Cancel</button>&emsp;
                    <button onClick={() => changeInv()}>Submit</button>
                </> : <>{type == 'HR' ? <>
                    <button onClick={async () => {
                        if (sel)
                            setShowP(true);
                        else setSel(true);
                    }}>{sel ? 'Add to Project' : 'Select'}</button>&emsp;
                    {sel ? <button onClick={() => { setSel(false) }}>Cancel</button> : <></>}&emsp;<button onClick={() => setHov(true)}> Edit </button></> : <></>}
                </>}
                <div onClick={() => document.getElementsByClassName('showfil')[0].classList.add('show_hide')} className='column'>
                    <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 5C14.9706 5 19 4.10457 19 3C19 1.89543 14.9706 1 10 1C5.02944 1 1 1.89543 1 3C1 4.10457 5.02944 5 10 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1C1 3.23 4.871 7.674 6.856 9.805C7.58416 10.5769 7.99291 11.5959 8 12.657V18L12 16V12.657C12 11.596 12.421 10.582 13.144 9.805C15.13 7.674 19 3.231 19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div className='filterList'>
                {filters.first_name && <Filtertag name={filters.first_name} id='Fname' />}
                {filters.last_name && <Filtertag name={filters.last_name} id='Lname' />}
                {filters.email && <Filtertag name={filters.email} id='Iemail' />}
            </div>
            <Filter get={getUsers} childFunc={childFunc} for='user' data={setData} setFil={setFil} url={type == 'PROJECT MANAGER' ? 'project/user_module_filter/' : 'hr/user_module_filter/'} />
            <div className=' top'>
                <table>
                    <tr className='border_bottom'>
                        {sel ? <th>Select</th> : <></>}
                        <th>NAME</th>
                        {/* <th>Hours</th> */}
                        <th>EMAIL</th>
                        <th>TYPE</th>
                        {type == 'PROJECT MANAGER' ? <th>SELECTED FOR PROJECTS</th> : <th>LOCATION</th>}
                        <th>SPECIALIZATION</th>
                        <th>EXPERIENCE</th>
                    </tr >
                    {!load ? data.map((inv) => { 
                        return <tr onClick={() => {
                            if (!hover && !jhov) {
                                localStorage.setItem(`user-${inv.id}`, JSON.stringify(inv));
                                navigate(`/users/${inv.id}`)
                            }
                        }} className='border_bottom'>
                            {sel ? <td
                                onMouseEnter={() => setJhov(true)}
                                onMouseLeave={() => setJhov(false)}
                            ><input id={inv.id} className='SuserCheck' type='checkbox'></input></td> : <></>}
                            {/* {setTimeout(() => {
                                <> */}
                                    <td>{inv.first_name + ' ' + inv.last_name}</td>
                                    {/* <td>{inv.rate}</td> */}
                                    <td>{inv.email}</td>
                                    {!hover ? <td>{inv.type_of_account}</td> :
                                        <td >
                                            <select onChange={(ed) => { changes.push({ type_of_account: ed.target.value, id: inv.id }) }}>
                                                <option selected={inv.type_of_account == 'CONSULTANT' ? true : false} value='CONSULTANT'>CONSULTANT</option>
                                                <option selected={inv.type_of_account == 'HR' ? true : false} value='HR'>HR</option>
                                                <option selected={inv.type_of_account == 'ACCOUNTANT' ? true : false} value='ACCOUNTANT'>ACCOUNTANT</option>
                                                <option selected={inv.type_of_account == 'PROJECT MANAGER' ? true : false} value='PROJECT MANAGER'>PROJECT MANAGER</option>
                                            </select>
                                        </td>}
                                    <td>{type == 'PROJECT MANAGER' ? <ShowSProject data={inv.project_selecteds} /> : inv.Get_detailes.state_region || '-'}</td>
                                    <td>{inv.Get_detailes.specififcation || '-'}</td>
                                    <td>{inv.Get_detailes.experiance || '-'}</td>
                                {/* </>
                            }, 100)
                            } */}
                        </tr>
                    }):<><TabRen/></>}
                </table>
            </div>
        </div> : <></>
    )
}
